import React from "react";

export default (props) => <img height="120px" alt="Header" {...props}></img>;
